import React from "react";
import ButtonPrimary from "../Components/subcomponents/ButtonPrimary";
import { Link } from "react-router-dom";

const Home = () => {


  const printFile = () => {
    // Adjust the path to match the file location in your build
    const fileUrl = '/photos/2024_sponsor_forms_local-1.pdf'; // Update this path as necessary

    // Create an iframe element
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    iframe.src = fileUrl;
    document.body.appendChild(iframe);

    // Wait for the iframe to load the PDF, then print it
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe); // Clean up
    };
  };


  return (
    <div className="max-w-4xl mx-auto bg-dark-blue p-6">
      <div className="relative mb-6">
        {/* Background Image */}
        <img
          src="src/assets/photos/CCF1ECD2-CFEF-4D68-A40F-2582996385101000018929.JPEG"
          alt="Car Show"
          className="w-full object-cover "
          style={{ objectPosition: "0% 10%", height: "25rem" }}
        />

        {/* Dark Gradient Overlay */}
        {/* <div className="absolute top-0 left-0 w-full h-28 bg-gradient-to-b from-black via-transparent to-transparent"></div> */}

        {/* Overlay Text */}
        <div className="absolute top-0 right-0 bg-black/30 backdrop-blur-none px-6 py-2 rounded-md text-right">
          <p className="text-white text-4xl font-extrabold leading-tight tracking-tight"
            style={{ textShadow: '0 2px 8px rgba(0,0,0,0.8)' }}>
            8 AM - 3 PM
          </p>
          <p className="text-white text-4xl font-extrabold leading-tight tracking-tight"
            style={{ textShadow: '0 2px 8px rgba(0,0,0,0.8)' }}>
            Basehor, KS
          </p>
          <p className="text-white text-4xl font-extrabold leading-tight tracking-tight"
            style={{ textShadow: '0 2px 8px rgba(0,0,0,0.8)' }}>
            September 12, 2026
          </p>
        </div>
      </div>

      {/* Event Information Section */}
      <section className="mb-6">
        <h1 className="text-4xl font-bold text-center mb-4">
          Basehor Car Show
        </h1>
        <p className="text-center text-lg">
          Our 29th Annual Basehor Car Show will take place on{" "}
          <strong>September 12th, 2026</strong>
        </p>
      </section>

      {/* Registration Info */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">Registration</h2>
        <p className="text-lg">
          <strong>Check back soon for next year's registration information!</strong>
        </p>
        <div className=" hidden py-6 ps-4">
          <Link to={"/registration"}>
            <ButtonPrimary className="">Register online here</ButtonPrimary>
          </Link>
        </div>
        <p className="hidden mt-4 text-sm">
          Day-of registration: 8:00 - 11:00am | Spectators are FREE!
        </p>
      </section>

      {/* Event Highlights */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">Event Highlights</h2>
        <ul className="list-disc list-inside space-y-2">
          <li>Enter the Loudest Exhaust Contest - cash prize to the winner!</li>
          <li>
            * Dash Plaques * Grab Bags (1st 150 to register) * Door Prizes *
          </li>
          <li>* Chairman’s Choice Trophy * Best of Show Awards *</li>
          <li>* Special Awards * Imports *</li>
          <li>* 50/50 Pot * Food Vendors * Raffle Items *</li>
        </ul>

        {/* Event Schedule Subsection */}
        <div className="mt-6 ">
          <h3 className="text-xl font-semibold mb-3">Event Schedule</h3>
          <ul className="list-inside space-y-1">
            <li>8:00 a.m. - Car Registration</li>
            <li>9:00 a.m. - Post the colors/National Anthem</li>
            <li>2:00 p.m. - Loudest Exhaust Contest</li>
            <li>2:30 p.m. - 50/50 Raffle Drawing</li>
            <li>~3:00 p.m. - Car Show Awards</li>
          </ul>
        </div>
      </section>

      {/* Sponsors */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">
          Special Thanks to Our 2025 Sponsors
        </h2>
        {sponsors.map((sponsor) => (
          <p key={sponsor}>{sponsor}</p>
        ))}
      </section>

      {/* Contact Information */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
        <p>
          For additional information, call <strong>Rich @ 208-406-9429</strong>{" "}
          or email <strong>basehorcarshow@gmail.com</strong>
        </p>
      </section>

      {/* Location Information */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">Location</h2>
        <p>Basehor-Linwood High School - 2108 155th Street - Basehor, KS</p>
        <p>
          Directions: 6 miles W of Kansas Speedway on Hwy 24/40 (State Avenue)
          to 155th Street, North 1 mile
        </p>
        <p className="mt-2 text-sm italic">
          Please remember - Basehor-Linwood High School is a drug & alcohol free
          zone. Thank you!
        </p>
      </section>

      {/* Sponsorship and Volunteer Info */}
      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4">Sponsorship & Volunteers</h2>
        <p>All proceeds benefit Basehor VFW Post #11499.</p>
        <p>No refunds on pre-registrations.</p>
      </section>
    </div>
  );
};

export default Home;

const sponsors = [
  "Bridget Kiggins realtor",
  "Butler Automotive and Muffler",
  "Edgar's Transmission Repair",
  "Envirotech Heating and Cooling",
  "Miller Sign Shoppe",
  "Elite Electric KC",
  "Snap Fitness-Basehor",
  "Weichert Realtors",
  "Welch and co",
  "Wholesale Batteries",
  "OverWatch FireArms",
  "First State Bank",
  "Clutch Click Photography",
  "7M RV rentals",
  "Tracy's Shave Ice",
];
